export const DETAIL_CARD_ICON_CLASS_NAME =
  'text-muted-foreground flex shrink-0 [&>svg]:size-4';

export const DETAIL_CARD_BODY_CLASS_NAME = 'flex flex-col gap-2.5 px-3 py-2.5';

export const DETAIL_CARD_ICON_TONE_CLASS_NAMES = {
  primary: 'bg-muted text-primary-soft-foreground',
  success: 'bg-success/15 text-success-soft-foreground',
  info: 'bg-info/15 text-info-soft-foreground',
  warning: 'bg-muted text-warning-soft-foreground',
  neutral: 'bg-muted text-foreground',
};
